import { render, staticRenderFns } from "./LivestreamChat.vue?vue&type=template&id=427c901d&scoped=true&"
import script from "./LivestreamChat.vue?vue&type=script&lang=js&"
export * from "./LivestreamChat.vue?vue&type=script&lang=js&"
import style0 from "./LivestreamChat.vue?vue&type=style&index=0&id=427c901d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c901d",
  null
  
)

export default component.exports